var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { theme } from "@sequentech/ui-essentials";
import { Box, styled } from "@mui/material";
import { Button, SelectInput, TextInput, required, SimpleForm, Toolbar, SaveButton, useNotify, } from "react-admin";
import { useMutation } from "@apollo/client";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { IApplicationsStatus, RejectReason } from "@/types/applications";
import FormDialog from "@/components/FormDialog";
import { CHANGE_APPLICATION_STATUS } from "@/queries/ChangeApplicationStatus";
import CancelOutlined from "@mui/icons-material/CancelOutlined";
var RejectBox = styled(Box)(function () { return ({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
}); });
var RejectButton = styled(Button)(function (_a) {
    var theme = _a.theme;
    return ({
        "borderColor": theme.palette.errorColor,
        "color": theme.palette.errorColor,
        "backgroundColor": theme.palette.white,
        "width": "max-content",
        "margin": "1rem 0",
        "&:hover": {
            backgroundColor: theme.palette.errorColor,
            color: theme.palette.white,
        },
    });
});
export var RejectApplicationButton = function (_a) {
    var label = _a.label, onClick = _a.onClick;
    return (_jsx(RejectBox, { children: _jsx(RejectButton, __assign({ onClick: function () { return onClick(true); } }, { children: _jsxs(Box, __assign({ style: { display: "flex", gap: "10px" } }, { children: [_jsx(CancelOutlined, { sx: { width: "20px", marginLeft: "10px", paddingTop: "4px" } }), label] })) })) }));
};
export var RejectApplicationDialog = function (_a) {
    var electionEventId = _a.electionEventId, task = _a.task, goBack = _a.goBack, rejectDialogOpen = _a.rejectDialogOpen, setRejectDialogOpen = _a.setRejectDialogOpen;
    var notify = useNotify();
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var rejectVoter = useMutation(CHANGE_APPLICATION_STATUS)[0];
    var handleReject = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!data) return [3 /*break*/, 2];
                    return [4 /*yield*/, rejectVoter({
                            variables: {
                                tenant_id: tenantId,
                                id: task === null || task === void 0 ? void 0 : task.id,
                                user_id: "",
                                area_id: task === null || task === void 0 ? void 0 : task.area_id,
                                election_event_id: electionEventId,
                                rejection_reason: data.rejection_reason,
                                rejection_message: data.rejection_message,
                            },
                        })];
                case 1:
                    errors = (_a.sent()).errors;
                    if (errors) {
                        notify(t("approvalsScreen.notifications.rejectError"), { type: "error" });
                        return [2 /*return*/];
                    }
                    notify(t("approvalsScreen.notifications.rejectSuccess"), { type: "success" });
                    goBack();
                    _a.label = 2;
                case 2:
                    setRejectDialogOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var rejectionChoices = function () {
        return Object.values(RejectReason).map(function (value) { return ({
            id: value,
            name: t("approvalsScreen.reject.reasons.".concat(value.toLowerCase())),
        }); });
    };
    return (_jsx(FormDialog, __assign({ open: rejectDialogOpen && task.status === IApplicationsStatus.PENDING, title: t("approvalsScreen.reject.label"), onClose: function () { return handleReject(); } }, { children: _jsx(SimpleForm, __assign({ defaultValues: {
                rejection_reason: "",
                rejection_message: "",
            }, onSubmit: function (data) {
                handleReject(data);
            }, sanitizeEmptyValues: true, toolbar: _jsx(Toolbar, __assign({ style: {
                    backgroundColor: "inherit",
                    display: "flex",
                    justifyContent: "flex-end",
                } }, { children: _jsx(SaveButton, { className: "election-event-save-button", icon: _jsx(CancelOutlined, {}), label: t("approvalsScreen.reject.label"), color: "error", style: { backgroundColor: theme.palette.errorColor } }) })) }, { children: _jsxs(Box, { children: [t("approvalsScreen.reject.confirm"), _jsx(SelectInput, { source: "rejection_reason", label: t("approvalsScreen.reject.rejectReason"), choices: rejectionChoices(), validate: required() }), _jsx(TextInput, { source: "rejection_message", label: t("approvalsScreen.reject.message"), fullWidth: true, validate: [
                            function (value, allValues) {
                                if (allValues.rejection_reason === RejectReason.OTHER && !value) {
                                    return t("approvalsScreen.reject.messageRequired");
                                }
                                return undefined;
                            },
                        ] })] }) })) })));
};
